const processReducer = (state, action, reducer) => reducer(state, action);

export default processReducer;
